import React from 'react';
import { Loader as ProgressLoader } from '@walmart-dataventures/shared-components';
import '@walmart-dataventures/shared-components/dist/esm/index.css';

function LoadingPage() {
	return <ProgressLoader showImage />;
}

LoadingPage.propTypes = {};

export default LoadingPage;
